// Robust handler for Crave/Dawn menus
(function () {
  const DESKTOP = window.matchMedia('(min-width: 990px)');

function handleGoToParent(e) {
  const DESKTOP = window.matchMedia('(min-width: 990px)');
  if (!DESKTOP.matches) return; // мобайл не чіпаємо

  // подіагностуємо, по чому клікнули
  const summary = e.target.closest('summary');
  console.log('[menu] click target=', e.target.tagName, 'summary?', !!summary);

  if (!summary) return;

  const details = summary.closest('details[data-parent-href]');
  console.log('[menu] details found?', !!details, details && details.dataset.parentHref);

  if (!details) return;

  e.preventDefault();
  e.stopPropagation();
  if (e.stopImmediatePropagation) e.stopImmediatePropagation();

  const href = details.dataset.parentHref;
  console.log('[menu] go →', href);
  if (href) window.location.href = href;
}

  // делегування на весь документ у capture‑режимі — переб’є скрипти теми
  document.addEventListener('click', handleGoToParent, true);
  document.addEventListener('pointerup', handleGoToParent, true);

  // підтримка клавіатури (Enter/Space) на десктопі
  document.addEventListener('keydown', function (e) {
    if (!DESKTOP.matches) return;
    if (e.key !== 'Enter' && e.key !== ' ') return;

    const summary = e.target.closest('summary');
    if (!summary) return;

    const details = summary.closest('details[data-parent-href]');
    if (!details) return;

    e.preventDefault();
    const href = details.dataset.parentHref;
    if (href) {
      console.log('[menu] go(kbd) →', href);
      window.location.href = href;
    }
  }, true);

  console.log('[menu] handler bound');
})();

// раскрытие/закрытие подменю на десктопе по hover с атрибутом [open]
(function () {
  const DESKTOP = window.matchMedia('(min-width: 990px)');
  document.querySelectorAll('details[data-parent-href]').forEach((d) => {
    d.addEventListener('mouseenter', () => { if (DESKTOP.matches) d.setAttribute('open', ''); });
    d.addEventListener('mouseleave', () => { if (DESKTOP.matches) d.removeAttribute('open'); });
  });
})();


